













import { clearLocalStorage, NAME_ROUTES } from '../../core/utils';
import { Component, Prop, Vue, Emit, Mixins } from 'vue-property-decorator';
import { StorageService, UserService } from '../../core/api';
import {
    RootStoreHelper,
    AuthStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import moment from 'moment';
@Component<SeeImageOnModal>({
    components:{
        
    }
})
export default class SeeImageOnModal extends Mixins(
    RootStoreHelper,
    AuthStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    @Prop({default: ''}) imgPath: string;

    @Emit()
    closeModal() {}
   
}
